export default "__VITE_ASSET__zeVizPVy__"